/**
 * ****************************************************************************
 * @description     :   MenuDropdown
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import React from "react";

/**
 * Component for dropdown will show when click on icon apps on right of header
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const MenuDropdown = () => {
    return (
        <>
        </>
    );
};

export default React.memo(MenuDropdown);
